<template>
  <tk-flex>
    <tk-flex middle center>
        <tk-image v-if="image" :src="require(`../../assets/images/${image}.png`)" style="height: 60px; width:60px" />
        <tk-flex column middle class="m-l-20">
          <div style="font-size:16px; color:#0B0D06">{{title}}</div>
          <div style="font-size:26px; color:#0B0D06">{{count}}</div>
        </tk-flex>
      </tk-flex>
  </tk-flex>
</template>

<script>
export default {
  props: {
    image: String,
    title: String,
    count: Number
  }
}
</script>

<style>

</style>
